import {makeAutoObservable} from 'mobx'
import AppStore from './AppStore'
import * as Api from '@/utils/api/api'

class TrackStore {
    map = null
    PAGE_SIZE = 8
    pageSize = 8
    pageNum = 1
    date = new Date()
    showMask = false
    refreshing = false

    constructor() {
        makeAutoObservable(this)
    }

    /**
     * 初始化 show handle
     */
    initShowHandle() {
        let {map} = this
        for (let key in map) {
            map[key].forEach(item => {
                item.showHandle = false
            })
        }
    }

    /**
     * 获取信息
     */
    async fetchMap() {
        try {
            if (AppStore.hasLogin) {
                const {pageSize, pageNum} = this
                const {map, totalNum} = await Api.trackMap({
                    pageSize,
                    pageNum
                })

                this.map = map

                this.initShowHandle()
            }
        } catch (error) {
        }
    }
}

const store = new TrackStore()

export default store
